/* =========================================================
   CART-DRAWER.JS — carrito AJAX sin recarga de página
   ========================================================= */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  if (!drawer) return;

  function openDrawer() {
    drawer.setAttribute('open', '');
    if (overlay) overlay.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.removeAttribute('open');
    if (overlay) overlay.removeAttribute('open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-drawer-close]')) { closeDrawer(); }
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function setLoading(isLoading) {
    drawer.classList.toggle('cart-loading', isLoading);
  }

  /* Vuelve a renderizar el contenido del drawer a partir del fragmento de la sección */
  function renderCartSection(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newItems = doc.querySelector('[data-cart-drawer-items]');
    var newFooter = doc.querySelector('[data-cart-drawer-footer]');
    var newCount = doc.querySelector('[data-cart-count]');

    var items = drawer.querySelector('[data-cart-drawer-items]');
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    if (newItems && items) items.innerHTML = newItems.innerHTML;
    if (newFooter && footer) footer.innerHTML = newFooter.innerHTML;

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      if (newCount) el.textContent = newCount.textContent;
    });
  }

  function refreshDrawer() {
    setLoading(true);
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) { renderCartSection(html); setLoading(false); })
      .catch(function () { setLoading(false); });
  }

  /* Agregar al carrito (formularios producto / quick add) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    setLoading(true);
    var formData = new FormData(form);

    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          var errBox = form.querySelector('[data-form-error]');
          if (errBox) errBox.textContent = data.description || 'No se pudo agregar el producto.';
          setLoading(false);
          return;
        }
        refreshDrawer();
        openDrawer();
      })
      .catch(function () { setLoading(false); });
  });

  /* Cambiar cantidad / eliminar línea (delegado, funciona tras re-render) */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var remove = e.target.closest('[data-cart-remove]');

    if (minus || plus) {
      var wrap = (minus || plus).closest('[data-cart-line]');
      var input = wrap.querySelector('input[type="number"]');
      var key = wrap.getAttribute('data-cart-line');
      var qty = parseInt(input.value, 10) + (plus ? 1 : -1);
      if (qty < 0) qty = 0;
      updateLine(key, qty);
    }
    if (remove) {
      e.preventDefault();
      var line = remove.closest('[data-cart-line]').getAttribute('data-cart-line');
      updateLine(line, 0);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-line] input[type="number"]')) {
      var wrap = e.target.closest('[data-cart-line]');
      updateLine(wrap.getAttribute('data-cart-line'), parseInt(e.target.value, 10) || 0);
    }
  });

  function updateLine(key, quantity) {
    setLoading(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshDrawer(); })
      .catch(function () { setLoading(false); });
  }

  /* Código de descuento */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-discount-form]');
    if (!form) return;
    e.preventDefault();
    var codeInput = form.querySelector('input[name="discount"]');
    var current = window.location.search.match(/discount=([^&]+)/);
    var code = codeInput.value.trim();
    setLoading(true);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function () { window.location.href = '/checkout?discount=' + encodeURIComponent(code); })
      .catch(function () { setLoading(false); });
  });

})();
